import axiosInstance from "../utils/axiosInstance";
import { PiDownloadSimpleBold } from "react-icons/pi";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import { useError } from "../contexts/ErrorContext";
import { Spinner } from "flowbite-react";

export function DownloadButton(props) {
  const [downloading, setDownloading] = useState(false);
  const { addError, addInfo } = useError();
  const download = () => {
    setDownloading(true);
    axiosInstance
      .get(props.url, {
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", props.filename); // Provide the filename
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        addError("Error downloading file");
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  return (
    <Tooltip title="Download">
      <button
        onClick={download}
        className="inline-flex items-center space-x-1 rounded bg-gray-300 px-4 py-2 font-bold text-gray-800 hover:bg-gray-400"
      >
        {downloading ? (
          <Spinner />
        ) : (
          <>
            <PiDownloadSimpleBold />
            <span>Download</span>
          </>
        )}
      </button>
    </Tooltip>
  );
}
